<template>
  <div>
    <v-card class="transparent elevation-0">
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
            <h1>Phone</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" :md="admin ? 2 : 2">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              :items="renderedDepots"
              item-text="name"
              return-object
              v-model="depot"
              prepend-icon="fas fa-map"
              clearable
              label="Depot...">
            </v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-switch class="justify-center" v-model="allSwitch" label="Show All" color="green"></v-switch>
          </v-col>
          <v-col cols="12" md="2">
            <h2 :style="'color: ' + cap_colour ">Total: {{ device_count }} / {{ device_cap }}</h2>
          </v-col>

          <v-col cols="12" md="2" class="text-center justify-space-between">
            <v-tooltip top color="secondary" v-if="admin">
              <template v-slot:activator="{ on }">
                <v-btn fab dark class="mx-2" color="indigo" @click="newScanPhone" v-on="on">
                  <v-icon dark>fas fa-qrcode</v-icon>
                </v-btn>
              </template>
              <span>Scan barcodes to add phones</span>
            </v-tooltip>
            <v-tooltip top color="secondary" v-if="admin">
              <template v-slot:activator="{ tooltip }">
                <v-btn class="mx-2" fab dark color="blue lighten-1" @click="newPhone" v-on="tooltip">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </template>
              <span>Create a new phone</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" md="1" v-if="admin">
            <v-btn class="justify-center" text @click="$refs.phone.click()" color="blue" block>
              <v-icon class="mr-2">cloud_upload</v-icon>
              <div v-if="file===''">Upload</div>
              <div v-else>{{this.file.name}}</div>
            </v-btn>
            <input v-show="false" ref="phone" type="file" @change="handleFileUpload" accept=".csv">
          </v-col>


        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="renderedPhones"
        :search="search"

      >
        <template v-slot:header.run="{ header }">
          <v-menu bottom float-left v-if="editPermission">
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">lock</v-icon>
            </template>
            <v-list>
              <v-list-item @click="lock">Lock those devices</v-list-item>
              <v-list-item @click="unlock">Unlock those devices</v-list-item>
            </v-list>
          </v-menu>
          <v-tooltip top color="secondary" v-if="editPermission">
            <template v-slot:activator="{ on }">
              <v-icon small @click="sendMessageDialog=true" v-on="on">mail</v-icon>
            </template>
            <span>Send a message to all those devices</span>
          </v-tooltip>
          <v-tooltip top color="secondary" v-if="editPermission">
            <template v-slot:activator="{ on }">
              <v-icon small @click="restart" v-on="on">cached</v-icon>
            </template>
            <span>Restart all those devices</span>
          </v-tooltip>
        </template>
        <template v-slot:item="props">
          <tr class="cursor"
              v-bind:class="{odd: props.index % 2, even: !props.index % 2}"
              :active="props.selected"
              @click="props.selected = !props.selected">
            <td style="text-align: center" >
              <input type="checkbox" :value="props.item.id" v-model="selected">
            </td>
            <td style="text-align: center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon :color="props.item.status === 'Removed' ? 'red' : props.item.status === 'Pending' ? 'blue' : 'green'" v-on="on">
                    fiber_manual_record
                  </v-icon>
                </template>
                <span>
                  {{props.item.status === 'Removed' ? 'This phone has been removed' : 'This phone has not been removed yet'}}
                </span>
              </v-tooltip>
            </td>
            <td style="text-align: center"
                v-for="(header, index) in headers"
                v-if="header.text !== 'Actions' && header.text !== 'Status' && header.text !== 'Run'"
                :key="index">
              {{props.item[header.value]}}
            </td>
<!--            <td v-if="admin " style="text-align: center">-->
<!--              <v-icon @click="toggleDeleteDialog(props.item)" color="red">delete</v-icon>-->
<!--            </td>-->
            <td v-if="editPermission" style="text-align: center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon  color="blue" @click="rowSelected(props.item) " v-on="on">
                    edit
                  </v-icon>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top color="secondary" v-if="admin">
                <template v-slot:activator="{ on }">
                  <v-icon color="red" @click="toggleDeleteDialog(props.item)" v-on="on" class="pl-1">
                    delete
                  </v-icon>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="sendMessageDialog" width="500px">
      <v-card>
        <v-card-title>
          <h3>Message those devices</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-container container--fluid grid-list-md>
          <v-textarea v-model="deviceMessage" label="Write the message you want to send..."></v-textarea>
        </v-container>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="sendMessageDialog = false; deviceMessage = ''">Cancel</v-btn>
          <v-btn text color="blue darken-1" @click="sendMessage">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title>
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text>
          You are about to delete this phone. This action cannot be undone. <br>
          Are you sure you want to proceed ?
          <v-text-field v-model="deleltResaon"
                        label="Resaon for delete"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-center">
            <v-btn text color="blue-grey lighten-2" @click="toBeDeleted=null; deleteDialog=false">No</v-btn>
            <v-btn text color="blue darken-1" @click="deletePhone">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" v-if="displayedItem" width="800px">
      <v-card>
        <v-card-title class="d-flex" style="position: relative"
                      :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
          <h2>{{editedIndex > -1 ? 'Edit Phone' : 'New Phone'}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="closeEditDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container container--fluid grid-list-xl pb-0>
            <v-row justify="space-around">
              <v-col cols="12" class="text-center justify-space-between">
                <v-tooltip top color="secondary" v-if="editPermission">
                  <template v-slot:activator="{ on }">
                    <v-icon  color="blue" @click="migrate(displayedItem) " v-on="on" :disabled="displayedItem.migrated">
                      sync_alt
                    </v-icon>
                  </template>
                  <span>Migrate to MobiControl</span>
                </v-tooltip>
                <v-tooltip top color="secondary" v-if="editPermission">
                  <template v-slot:activator="{ on }">
                    <v-icon color="blue" @click="resetSIM(displayedItem)" v-on="on" class="pl-1">
                      sync
                    </v-icon>
                  </template>
                  <span>Reset SIM</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row justify="space-around">
              <v-list three-line>
                <v-row justify="center" align="center">
                  <v-col cols="12" sm="12" md="6" class="py-0" v-for="(key, index) in Object.keys(displayedItem)"
                         :key="index">
                    <v-list-item ripple>
                      <v-list-item-action>
                        <div v-if="key === 'date_added'">
                          <v-icon color="green">{{icons[key]}}</v-icon>
                        </div>
                        <div v-else-if="key === 'status'">
                          <v-icon :color="displayedItem[key] === 'Removed' ? 'red' : displayedItem[key] === 'Pending' ? 'blue' : 'green'">fiber_manual_record
                          </v-icon>
                        </div>
                        <div v-else>
                          <v-icon :color="key === 'date_removed' ? 'orange' : '#00a7d3'">{{icons[key]}}</v-icon>
                        </div>
                      </v-list-item-action>
                      <v-list-item-content class="pt-0">
                        <div v-if="!fab">
                          <v-list-item-title>{{capitalizeFirstLetter(key)}}</v-list-item-title>
                          <v-list-item-subtitle style="overflow: hidden" v-on="on">
                            {{displayedItem[key]}}
                          </v-list-item-subtitle>
                        </div>
                        <div v-else>
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <div v-if="key === 'depot_id'">
                              <v-select
                                :items="renderedDepots"
                                item-value="id"
                                item-text="name"
                                v-model="editedItem[key]"
                                label="Depot"
                                :disabled="!admin"></v-select>
                            </div>
                            <div v-else-if="key === 'status'">
                              <v-select
                                :items="status"
                                v-model="editedItem[key]"
                                label="Status"
                                disabled></v-select>
                            </div>
                            <div v-else>
                              <v-text-field v-model="editedItem[key]"
                                            :label="capitalizeFirstLetter(key)"
                                            :disabled="readOnly.includes(key) || (adminEditabled.includes(key) && !admin)"
                              ></v-text-field>
                            </div>
                          </v-form>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                </v-row>
              </v-list>
            </v-row>

            <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col md="2" cols="12" class="text-center">
                <v-btn
                  text
                  @click="editDialog=false;"
                  color="blue-grey lighten-2"
                >Cancel
                </v-btn>
              </v-col>
              <v-col md="2" cols="12" class="text-center">
                <v-btn
                  text
                  @click="saveChanges"
                  color="blue darken-1"
                >Save
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="scanPhonesDialog"
      max-width="700px"
    >
      <v-card>
        <v-card-title>
          <h2>Add phones by scanning</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeScanDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editedItem.manufacturer"
            label="Manufacturer"
            prepend-icon="receipt"
          ></v-text-field>
          <v-text-field
            v-model="editedItem.model"
            label="Model"
            prepend-icon="receipt"
          ></v-text-field>

          <div class="justify-center text-center">
            <v-btn outlined large color="blue" @click="toggleScanning">{{isScanning ? 'Stop' : 'Start scan'}}</v-btn>
            <v-quagga v-if="isScanning" :onDetected="excecute" :readerSize="readerSize"
                      :readerTypes="['code_128_reader']"></v-quagga>
            <h2 v-if="isScanning" style="color:blue; margin-top: 20px;">{{'detected code : ' + infos}}</h2>
          </div>

          <div v-if="isScanning" style="padding-bottom:250px;"></div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            text
            @click="closeScanDialog"
            color="blue-grey lighten-2"
          >Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>





  </div>
</template>

<script>
    import axios from 'axios';
    import Papa from 'papaparse';

    // @vuese
    // Phones table
    // @group ManageDevices
    export default {
        name: "ManagePhonesTable",
        data() {
            return {
                readerSize: {
                    width: 325,
                    height: 300
                },
                detecteds: [],
                isScanning: false,
                timer: '',
                infos: null,
                play: true,

                dateAddedMenu: false,
                dateRemovedMenu: false,
                valid: false,
                fab: false,
                file: '',
                requiredRule: [
                    v => !!v || 'This field is required.'
                ],
                icons: {
                    id: 'card_travel',
                    depot_id: 'location_city',
                    manufacturer: 'phone_in_talk',
                    model: 'smartphone',
                    imei: 'phonelink_setup',
                    date_added: 'watch_later',
                    date: 'event_note',
                    allocated_to: 'person',
                    android_version: 'android',
                    date_removed: 'watch_later',
                    play_services_version: 'room_service',
                    notes: 'speaker_notes',
                    serial: 'vpn_key',
                    mdm_id: 'grid_on',
                    last_used: 'watch',
                    last_used_by: 'people',
                },
                readOnly: [
                    "id",
                    "date_added",
                    "date_removed",
                    "status",
                    "mdm_id",
                    "last_used",
                    "last_used_by"
                ],
                adminEditabled: [
                    "depot_id",
                    "imei",
                    "serial",
                    "manufacturer",
                    "model",
                ],
                search: null,
                toBeDeleted: null,
                deleteDialog: false,
                allSwitch: false,
                editedIndex: -1,
                editedItem: {
                    id: 0,
                    depot_id: null,
                    manufacturer: null,
                    model: null,
                    imei: null,
                    date_added: null,
                    status: null,
                    allocated_to: null,
                    android_version: null,
                    play_services_version: null,
                    notes: null,
                    date_removed: null,
                    mdm_id: null,
                    serial: null,
                    last_used: null,
                    last_used_by: null
                },
                defaultPhone: {
                    id: 0,
                    depot_id: null,
                    manufacturer: null,
                    model: null,
                    imei: null,
                    date_added: null,
                    status: 'Pending',
                    allocated_to: null,
                    android_version: null,
                    play_services_version: null,
                    notes: null,
                    date_removed: null,
                    mdm_id: null,
                    serial: null,
                    last_used: null,
                    last_used_by: null
                },
                editDialog: false,
                displayedItem: null,
                selected: [],
                sendMessageDialog: false,
                deviceMessage: '',
                region: null,
                scanPhonesDialog: false,
                ImeiScanned: [],
                deleltResaon:null,
                reload: false,
                status:[
                  "Active",
                  "Removed",
                  "Pending",
                ],
                depot: null,
                startTimer:null,
                files:[],
                info:'',
            }
        },
        methods: {
            // @vuese
            // Restarts the selected devices
            migrate(phone) {
              if (confirm("Are you sure you want to initiate MobiControl migration? The device will be wiped if you proceed.")) {
                axios.post(process.env.API_URL + '/phones/' + phone.id + '/migrate', null)
                  .then((response) => {
                    this.$store.commit('displaySnackbar', 'Device migration has been initiated.');
                  })
                  .catch((response) => {
                    this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                  })
              }
            },
            resetSIM(phone) {
              if (confirm("Are you sure you want to reset SIM status?")) {
                axios.post(process.env.API_URL + '/phones/' + phone.id + '/resetsim', null)
                  .then((response) => {
                    this.$store.commit('displaySnackbar', 'SIM status reset successfully.');
                  })
                  .catch((response) => {
                    this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                  })
              }
            },
            restart() {
                let body = {"ids": []};


                for (var row of this.selected) {
                    if (row.mdm_id !== null) {
                        body.ids.push(row.mdm_id)
                    }
                }

                axios.post(process.env.API_URL + '/phones/restart', body)
                    .then((response) => {
                        this.$store.commit('displaySnackbar', body.ids.length + ' device(s) have been restarted');
                        this.selected = [];
                    })
            },
            lock() {
                let body = {"ids": []};

                for (var row of this.selected) {
                    if (row.mdm_id !== null) {
                        body.ids.push(row.mdm_id)
                    }
                }

                axios.post(process.env.API_URL + '/phones/lock', body)
                    .then((response) => {
                        this.$store.commit('displaySnackbar', body.ids.length + ' device(s) have been locked.');
                        this.selected = [];
                    })
            },
            unlock() {
                let body = {"ids": []};

                for (var row of this.selected) {
                    if (row.mdm_id !== null) {
                        body.ids.push(row.mdm_id)
                    }
                }

                axios.post(process.env.API_URL + '/phones/unlock', body)
                    .then((response) => {
                        this.$store.commit('displaySnackbar', body.ids.length + ' device(s) have been unlocked.');
                        this.selected = [];
                    })
            },
            sendMessage() {
                let body = {"ids": [], "message": ''};

                for (var row of this.selected) {
                    if (row.mdm_id !== null) {
                        body.ids.push(row.mdm_id)
                    }
                }
                body.message = this.deviceMessage;

                axios.post(process.env.API_URL + '/phones/message', body)
                    .then((response) => {
                        this.sendMessageDialog = false;
                        this.deviceMessage = '';
                        this.$store.commit('displaySnackbar', 'Message sent to ' + this.selected.length + ' device(s).');
                        this.selected = []
                    })
            },
            // @vuese
            // Resets every relevant variable to default (editedIndex, editedItem, displayedItem) and opens the editDialog
            newPhone() {
                this.editedIndex = -1;
                this.displayedItem = Object.assign({}, this.defaultPhone);
                this.editedItem = Object.assign({}, this.defaultPhone);
                this.fab = true;
                this.editDialog = true;
            },
            // @vuese
            // Function used for display purposes. Takes a key of the response JSON replaces '_' by a space and capitalizes the first letter.
            // @arg Takes a string you want to display as a field Name and returns a capitalized-multi-words label.
            capitalizeFirstLetter(string) {
                string = string.replace(/_/g, ' ');
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            // @vuese Stores the phone Object the user just selected in displayedItem (for the information dialog),
            // stores the index of the phone Object and opens the editDialog
            // @arg Takes the phone Object as an argument
            rowSelected(item) {
              this.displayedItem = {
                  id: item['id'],
                  depot_id: item['depot_id'],
                  manufacturer: item['manufacturer'],
                  model: item['model'],
                  imei: item['imei'],
                  date_added: item['date_added'],
                  status: item['status'],
                  allocated_to: item['allocated_to'],
                  android_version: item['android_version'],
                  play_services_version: item['play_services_version'],
                  notes: item['notes'],
                  date_removed: item['date_removed'],
                  mdm_id: item['mdm_id'],
                  serial: item['serial'],
                  last_used: item['last_used'],
                  last_used_by: item['last_used_by']
              },
                this.editedItem = Object.assign({}, this.displayedItem);
                this.editedItem['depot_id'] = this.editedItem['depot_id'] * 1;
                this.editedIndex = this.phonesItems.indexOf(item);
                this.fab = true;
                this.editDialog = true;
            },
            // @vuese Toggles delete dialog and stores in toBeDeleted variable the phone Object the user wants to delete
            // @arg Takes the phone Object the user wants to delete as an argument.
            toggleDeleteDialog(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            // @vuese Deletes toBeDeleted phone Object and POST those changes on the API.
            deletePhone() {
                let index = this.phonesItems.indexOf(this.toBeDeleted);

                // record the delete reason
                if(this.deleltResaon !== null){
                  this.toBeDeleted['notes'] = this.deleltResaon;
                  axios.put(process.env.API_URL + '/phones/' + this.toBeDeleted['id'], this.toBeDeleted)
                    .then((response) => {
                      // delete the phone
                      axios.delete(process.env.API_URL + '/phones/' + this.toBeDeleted.id)
                        .then((response) => {
                          this.phonesItems.splice(index, 1);
                          this.deleteDialog = false;
                          this.updateDataTable();
                          this.$store.commit('displaySnackbar', 'Phone deleted successfully');
                        })
                        .catch((response) => {
                          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                    })
                    .catch((response) => {
                      this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
                }
            },
            closeEditDialog() {
                this.editedIndex = -1;
                this.displayedItem = Object.assign({}, this.defaultPhone);
                this.editedItem = Object.assign({}, this.defaultPhone);
                this.editDialog = false;
            },
            // @vuese
            // Saves changes on a phone Object post those changes on the API. Handles both cases: editing or creating new phone.
            // Resets displayedItem variable to default.
            saveChanges() {
                let body = this.editedItem;

                if (this.editedIndex > -1) {
                    axios.put(process.env.API_URL + '/phones/' + body.id, body)
                        .then((response) => {
                            // this.displayedItem = Object.assign({}, response.data);
                            // Object.assign(this.phonesItems[this.editedIndex], this.displayedItem);
                            this.updateDataTable();
                            this.$store.commit('displaySnackbar', 'Changes saved.');
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                } else {
                    axios.post(process.env.API_URL + '/phones', body)
                        .then((response) => {
                            // this.displayedItem = Object.assign({}, response.data);
                            // this.phonesItems.push(this.displayedItem);
                            this.updateDataTable();
                            this.$store.commit('displaySnackbar', 'Phone created.');
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                }
                this.editDialog = false;
            },
            updateDataTable() {
              this.reload = !this.reload;
            },
            async handleFileUpload(){
              this.file = this.$refs.phone.files[0];
              const pointIndex = this.file.name.lastIndexOf(".");
              const fileSuffix = this.file.name.substr(pointIndex);
              if(fileSuffix == ".CSV" || fileSuffix == ".csv") {
                  Papa.parse(this.file, {
                    header: true,
                    complete: async (results) => {
                      this.$store.commit('displaySnackbar', 'Processing file...');
                      let success = 0;
                      for (const phone of results.data) {
                        if(phone['IMEI/MEID'] !== '' && phone['Serial Number'] !== '' && phone['Model'] !== ''){
                          let body = {
                              manufacturer: 'Samsung',
                              model: phone['Model'].toString(),
                              imei: phone['IMEI/MEID'].toString(),
                              serial: phone['Serial Number'].toString(),
                          };

                          await axios.post(process.env.API_URL + '/phones', body)
                            .then(() => {
                              success++;
                            })
                            .catch((response) => {
                              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                            });
                        }
                      }
                      this.$store.commit('displaySnackbar', "Created " + success + " out of " + (results.data.length - 1) + " phones")
                      this.updateDataTable();
                    }
                  });
                } else alert("Not a CSV file");

            },
            newScanPhone() {
                this.editedItem = Object.assign({}, this.defaultPhone);
                this.scanPhonesDialog = true;
            },
            closeScanDialog() {
                this.isScanning = false;
                this.ImeiScanned = [];
                this.scanPhonesDialog = false;
            },
            excecute(data) {
                this.logIt(data);
                this.wait(4000);
            },
            logIt(data) {
                if (this.play) {
                    this.play = false;
                    // console.log('detected', data);
                    this.infos = data.codeResult.code;
                    console.log(this.infos);
                    console.log(this.ImeiScanned);


                    if (this.editedItem.manufacturer == null || this.editedItem.model == null) {
                        this.$store.commit('displaySnackbar', 'Please enter a manufacturer and a model');
                    } else {
                        if (this.ImeiScanned.includes(data.codeResult.code)) {
                            this.$store.commit('displaySnackbar', 'this phone is already registered');
                        } else {
                            this.editedItem.imei = data.codeResult.code;
                            axios.post(process.env.API_URL + '/phones', this.editedItem)
                                .then((response) => {
                                    this.$store.commit('displaySnackbar', 'Phone created.');
                                    this.ImeiScanned.push(this.editedItem.imei);
                                    this.editedItem.imei = null;
                                })
                                .catch((response) => {
                                    this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                                    this.editedItem.imei = null;
                                })
                        }
                    }
                }
            },
            wait(ms) {
                var start = new Date().getTime();
                var end = start;
                while (end < start + ms) {
                    end = new Date().getTime();
                }
                this.play = true;
            },
            toggleScanning() {
                this.isScanning = !this.isScanning;
            },
        },

        computed: {
            device_cap() {
              if (this.depot == null) return 0;
              if (this.depot.id == 0) {
                return Infinity;
              } else {
                return this.depot.active_phone_cap;
              }
            },
            device_count() {
                let count = 0;
                if (this.phonesItems) {
                  this.phonesItems.forEach((phone) => {
                    if (phone.date_removed == null) count++;
                  });
                }
                return count;
            },
            cap_colour() {
              if (this.device_count < this.device_cap) return 'green';
              if (this.device_count == this.device_cap) return 'orange';
              return 'red';
            },
            editPermission() {
                if (this.depot == null) return false;
                if (this.depot.id === 0) return this.admin;
                return this.admin || this.$store.getters['auth/hasPermissionRegionId']('phone_edit', this.depot.region_id);
            },
            admin() {
                return this.$store.getters['auth/hasPermission']('device_admin');
            },
            headers() {
                let headers = [

                    {text: 'Run', value: 'run', align: 'center', sortable: false},

                    {text: 'Status', value: 'status', align: 'center', sortable: true},
                    {text: 'ID', value: 'id', align: 'right', sortable: true},
                    {text: 'Hexnode ID', value: 'mdm_id', align: 'right', sortable: true},
                    {text: 'Manufacturer', value: 'manufacturer', align: 'center', sortable: true},
                    {text: 'Model', value: 'model', align: 'center', sortable: true},
                    {text: 'IMEI', value: 'imei', align: 'center', sortable: true},
                    // {text: 'Serial', value: 'serial', align: 'center', sortable: false},
                    {text: 'Date Added', value: 'date_added', align: 'center', sortable: true},
                    // {text: 'MDM ID', value: 'mdm_id', align: 'center', sortable: false},
                    {text: 'Last Used', value: 'last_used', align: 'center', sortable: true},
                    {text: 'Last Used By', value: 'last_used_by', align: 'center', sortable: true},
                    {text: 'Allocated To', value: 'allocated_to', align: 'center', sortable: true},
                    {text: 'Android Version', value: 'android_version', align: 'center', sortable: true},
                    // {text: 'Notes', value: 'notes', align: 'center', sortable: false},
                ];
                if (this.editPermission) {
                    headers.push({text: 'Actions', value: 'actions', align: 'center', sortable: true, width: '5%'});
                }
                return headers;
            },
            // @vuese
            // Array of phone Objects that are displayed in the phonesTable
            renderedPhones() {
                if (this.phonesItems == null) return [];
                let output;
                output = this.phonesItems.filter((phone) => {
                    return phone.status === 'Active' || this.allSwitch
                });
                return output
            },
            renderedDepots(){
              if (this.depots == null) return [];
              if(this.depots)
              this.depots =  this.depots.sort(function(a,b){
                if(a.name < b.name) return -1;
                if(a.name > b.name) return 1;
                return 0;
              });
              if (this.admin) {
                let gol = {
                  "id": 0,
                  "region_id": 0,
                  "region_name": "Global",
                  "name": "Global",
                  "address": "",
                  "address2": "",
                  "suburb": "",
                  "state": "NSW",
                  "postcode": "",
                  "code": "",
                  "wms": false,
                  "parent_depot": null,
                  "active_phone_cap": "0"
                };
                this.depots.unshift(gol)
              }
              if (this.depots.length > 0) {
                this.depot = this.depots[0];
              }
              return this.depots;
            }
        },
        asyncComputed: {
            async phonesItems() {
              if (this.reload || !this.reload) {
                if (this.depot == null) {
                  return [];
                } else {
                  return await axios.get(process.env.API_URL + '/phones/depots/' + this.depot.id)
                    .then((response) => {
                      return response.data;
                    })
                    .catch((response) => {
                      this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                      return [];
                    });
                }
              }

            },
            async depots() {
              return await axios.get(process.env.API_URL +'/depots')
                .then((response) => {
                  if (response.status === 200) {
                    return response.data;
                  } else {
                    return [];
                  }
                })
                .catch((error) => {
                  return [];
                });
        },
    }
    }
</script>

<style scoped>
  .col-6 .v-input--selection-controls, .v-data-table__wrapper .v-input--selection-controls {
    justify-content: center;
    margin: 0;
  }

  .v-card__text .v-list__tile__action {
    align-items: unset;
  }

  .container.grid-list-xl .layout .flex {
    padding: 0 12px;
  }

  input[type=checkbox] {
    height: 25px;
    width: 25px;
  }

  >>> .viewport video[data-v-8d1d8f02] {
    left: 50%;
    width: 400px;
    margin: 50px 0 25px -200px;
  }

  >>> .viewport canvas[data-v-8d1d8f02] {
    position: absolute;
    left: 50%;
    width: 400px;
    margin: 50px 0 25px -200px;
  }

  @media only screen and (max-width: 700px) {

    >>> .viewport video[data-v-8d1d8f02] {
      left: 50%;
      width: 275px;
      /*margin: 50px 0 25px -175px;*/
    }

    >>> .viewport canvas[data-v-8d1d8f02] {
      position: absolute;
      left: 50%;
      width: 275px;
      /*margin: 50px 0px 25px -175px;*/
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/util/ManageDevices/ManagePhonesTable.vue